import React, { ReactNode } from 'react'
import { P } from '@/components/common/Typo'
import ProgressBar from '@/components/common/ProgressBar'
import { analyseStoreOrder } from 'src/utils/order'
import useAppContext from '@/hooks/useAppContext'
import { useTranslate } from '@tolgee/react'
import { useSelector } from 'react-redux'
import { selectStoreOrder } from '@/redux/order'
import IconRocketship from '@/components/icons/IconRocketship'
import IconAddMoreToCart from '@/components/icons/IconAddMoreToCart'

const CartProgressBars = (): ReactNode => {
  const { t } = useTranslate()
  const storeOrder = useSelector(selectStoreOrder)
  const { formatMoney } = useAppContext()

  if (!storeOrder?.data) return null

  const {
    hasMinimumOrder,
    hasDeliveryFee,
    hasFreeDelivery,
    reachedMinOrder,
    reachedFreeDelivery,
    amountToMinOrder,
    amountToFreeDelivery,
  } = analyseStoreOrder(storeOrder.data)

  return hasMinimumOrder || (hasDeliveryFee && hasFreeDelivery) ? (
    <div className="mt-2.5 w-full">
      <div className="bg-[#FFF] p-2.5">
        {hasMinimumOrder && (
          <div className="flex w-full flex-row">
            <div className="mr-2.5 flex items-center justify-between">
              {reachedMinOrder ? <IconRocketship /> : <IconAddMoreToCart />}
            </div>
            <div className="flex w-full flex-col">
              <P className="mb-1 mt-0 text-[#515151]">
                {reachedMinOrder
                  ? t(`Hurray! You've hit the min order of {min}`, {
                      min: formatMoney(storeOrder.data?.minimumOrder),
                    })
                  : t('{amount} more to min order of {min}', {
                      amount: formatMoney(amountToMinOrder),
                      min: formatMoney(storeOrder.data?.minimumOrder),
                    })}
              </P>
              <ProgressBar
                percent={
                  (storeOrder.data?.subtotal / storeOrder.data?.minimumOrder) *
                  100
                }
              />
            </div>
          </div>
        )}
        {hasMinimumOrder && hasDeliveryFee && hasFreeDelivery && (
          <div className="h-2.5" />
        )}
        {hasDeliveryFee && hasFreeDelivery && (
          <React.Fragment>
            <P className="mb-1 mt-1 text-[#515151]">
              {reachedFreeDelivery
                ? t(`Hurray! You've hit the free delivery amount`)
                : t('{amount} more to free delivery', {
                    amount: formatMoney(amountToFreeDelivery),
                  })}
            </P>
            <ProgressBar
              percent={
                ((storeOrder.data?.deliveryFreeAfter - amountToFreeDelivery) /
                  storeOrder.data?.deliveryFreeAfter) *
                100
              }
            />
          </React.Fragment>
        )}
      </div>
    </div>
  ) : null
}

export default CartProgressBars
